import { createFileRoute } from '@tanstack/react-router'

import LecturePage from '@/lecture/components/LecturePage/LecturePage'

export const Route = createFileRoute(
  '/_learning/channel/$channel/$topic/$lecture/{-$suffix}/{-$id}',
)({
  component: LecturePage,
})
